<template>
  <div>
    <validation-provider v-slot="{ errors }" rules="image|size:2048">
      <b-field
        name="Company Logo For Co-Branded Page"
        class="personal-info__field block-title"
        :class="(editable)?'mt-13':'mt-35'"
        :type="{ 'is-danger': errors.length }"
        :message="errors"
        custom-class="personal-info__field-label"
      >
        <template slot="label">
          Logo image
          <b-tooltip
            :label='tooltipText'
            class="tooltip is-gray"
            type="is-info"
            size="is-large"
            :position="getTooltipPositionByContentWidth(330, 'is-bottom')"
            :delay="200"
            animated
            multilined>
          <b-icon pack="fa" size="is-small" icon="question-circle" />
        </b-tooltip>
        </template>
      </b-field>
    </validation-provider>

    <template v-if="editable">
      <p class="p-logo">Upload your logo in PNG, GIF, or JPG format. Recommended size: 218×144 px.
      Max. file size: 1 MB.</p>
      <b-field class="image-section">
        <div class="image-section-image-wrapper" :class="{'no-image': !logo}">
          <img
            :alt="alt"
            :src="logo ? logo : noLogoImageUrl"
          >
        </div>
        <div class="image-section-btns">
          <b-button
            class="is-pulled-left"
            type="outlined"
            onclick="document.getElementById('file-input').click();"
          >
            CHANGE LOGO
          </b-button>
          <b-button
            :disabled="logo === noLogoImageUrl || !logo"
            class="is-pulled-left"
            type="outlined"
            @click="delImage"
          >
            DELETE LOGO
          </b-button>
        </div>
      </b-field>
      <input
        accept="image/jpeg, image/png, image/gif"
        @change="onFileInputChange"
        ref="fileInput"
        id="file-input"
        type="file"
        name="name"
        style="display: none"
      />
    </template>

    <template v-else>
      <p class="p-logo">Upload your logo in PNG, GIF, or JPG format. Recommended size: 218×144 px.
      Max. file size: 1 MB.</p>
      <!--suppress HtmlUnknownTarget -->
      <div class="image-section-image-wrapper" :class="{'no-image': !logo}">
        <img
            :alt="alt"
            :src="logo ? logo : noLogoImageUrl"
        >
      </div>
    </template>
  </div>
</template>

<script>

import Vue from 'vue';
import EditImage from '@/components/Modal/EditImage.vue';
import { getTooltipPositionByContentWidth } from '@/utils/getTooltipPosition';

export default {
  name: 'CoBrandedPageLogoImage',
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    alt: {
      type: String,
      default: '',
    },
    logo: {
      type: String,
      default: '',
    },
    blobImage: {
      type: Blob,
      default: null,
    },
    noLogoImageUrl: {
      type: String,
      default: '',
    },
    appendTo: {
      type: HTMLElement,
      default: null,
    },
    cropperImageWidth: {
      type: Number,
      default: 218,
    },
    cropperImageHeight: {
      type: Number,
      default: 145,
    },
    tooltipText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cropModal: null,
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  methods: {
    getTooltipPositionByContentWidth,
    delImage() {
      const logo = this.noLogoImageUrl;
      this.updateLogoValue(logo);
      this.updateBlobImageValue(null);
    },
    updateLogoValue(newValue) {
      this.$emit('update:logo', newValue);
    },
    updateBlobImageValue(newValue) {
      this.$emit('update:blobImage', newValue);
    },
    onFileInputChange(event) {
      const fReader = new FileReader();
      if (event.target.files[0].type && (event.target.files[0].type !== 'image/jpeg') && (event.target.files[0].type !== 'image/png') && (event.target.files[0].type !== 'image/gif')) {
        this.$buefy.snackbar.open({
          type: 'is-danger',
          message: 'Please upload a file in the PNG, GIF, or JPG format',
          position: 'is-top',
          indefinite: true,
          actionText: ' ',
        });
      } else {
        fReader.readAsDataURL(event.target.files[0]);
        const callShowEditImage = function callShowEditImage() {
          this.showEditImage(fReader.result, true);
        };
        fReader.onloadend = callShowEditImage.bind(this);
      }
    },
    showEditImage(file, modalIsActive) {
      const Component = Vue.extend(EditImage);
      this.cropModal = new Component({
        propsData: {
          width: this.cropperImageWidth,
          height: this.cropperImageHeight,
          show: modalIsActive,
          file,
        },
      });
      this.cropModal.$store = this.$store;
      this.cropModal.$mount();
      this.cropModal.$on('submit', (response) => {
        if (response) {
          this.updateBlobImageValue(response);
          const logo = URL.createObjectURL(response);
          this.updateLogoValue(logo);
          this.appendTo.removeChild(this.cropModal.$el);
        }
      });
      this.cropModal.$on('close', () => {
        this.appendTo.removeChild(this.cropModal.$el);
      });
      this.appendTo.appendChild(this.cropModal.$el);
      this.$refs.fileInput.value = '';
    },
  },
};
</script>

<style scoped lang="stylus">
.image-section
  @media screen and (max-width 500px)
    flex-direction column

.image-section >>> img
  width 100%
  height 100%
  object-fit contain

.image-section-btns
  display flex
  flex-direction column
  margin-left 15px
  @media screen and (max-width 500px)
    margin-top 5px
    margin-left 0
  .button
    margin 10px
    height 48px
    min-width 123px
    font-size 19px
    font-weight 400
    text-transform uppercase
    @media screen and (max-width 500px)
      margin-top 0
      margin-bottom 15px
      margin-left 0
      margin-right 0

.block-title >>> .personal-info__field-label.label
  margin-bottom 0.5em
  font-size 16px
.block-title-input >>> label.label
  margin-bottom 0.5em
.p-logo
  padding-bottom 15px
</style>
